import React from "react";
//eslint-disable-next-line import/no-unresolved
import logo from "multiplo-theme/components/Layout/img/logo.jpg?width=82";

const LogoFooter = () => (
  <figure className="icon">
    <img
      src={logo}
      width="82"
      height="82"
      alt="Comune di Cavriago"
    />
  </figure>
);

export default LogoFooter;
